import { ProjectElementType } from '@kfolks/types'
import { z } from 'zod'

export const projectElementCreateSchema = z.object({
	elementType: z.enum(ProjectElementType),
	name: z.string().min(1),
	description: z.string().optional(),
	environment: z.string().optional(),
	url: z.string().optional(),
	isActive: z.boolean().default(true),
})

export const projectElementUpdateSchema = projectElementCreateSchema.partial()

export type ProjectElementCreateInput = z.infer<typeof projectElementCreateSchema>
export type ProjectElementUpdateInput = z.infer<typeof projectElementUpdateSchema>
